import React from "react";
import PropTypes from "prop-types";

import Page from "../components/Page";
import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";

import CreateReportForm from "../components/forms/CreateReportForm";

const CEShiftReportPage = (props) => (
  <Page title="Rapportage">
    <CenteredPageContentContainer>
      <PaperContainer title="Vul rapportage in">
        <CreateReportForm
          companyEmail={props.match.params.company_email}
          employeeEmail={props.match.params.employee_email}
          shiftId={props.match.params.shift_id}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

CEShiftReportPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      company_email: PropTypes.string.isRequired,
      employee_email: PropTypes.string.isRequired,
      shift_id: PropTypes.string.isRequired,
    }),
  }),
};

export default CEShiftReportPage;



// WEBPACK FOOTER //
// ./src/pages/CEShiftReportPage.js